var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "0%",
    x2: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F26221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5851F"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.548 5.594c0-.55.192-1.019.573-1.407.38-.387.842-.582 1.383-.582.539 0 1 .195 1.383.582.38.388.572.857.572 1.407 0 .551-.192 1.02-.572 1.408-.383.388-.844.581-1.383.581-.541 0-1.003-.193-1.383-.581-.381-.388-.573-.857-.573-1.408zm-3.54 0c0 .776.198 1.677.591 2.703.393 1.026.829 1.946 1.308 2.759.481.813 1.039 1.651 1.679 2.514.638.863 1.081 1.44 1.327 1.727l.591.694.589-.638c.37-.45.819-1.057 1.347-1.82.527-.764 1.062-1.582 1.604-2.459.541-.876 1.001-1.814 1.382-2.815.381-1 .572-1.889.572-2.665 0-1.551-.534-2.87-1.604-3.959S7.028.002 5.504.002c-1.525 0-2.823.544-3.891 1.633C.544 2.724.008 4.043.008 5.594z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M3.548 5.594c0-.55.192-1.019.573-1.407.38-.387.842-.582 1.383-.582.539 0 1 .195 1.383.582.38.388.572.857.572 1.407 0 .551-.192 1.02-.572 1.408-.383.388-.844.581-1.383.581-.541 0-1.003-.193-1.383-.581-.381-.388-.573-.857-.573-1.408zm-3.54 0c0 .776.198 1.677.591 2.703.393 1.026.829 1.946 1.308 2.759.481.813 1.039 1.651 1.679 2.514.638.863 1.081 1.44 1.327 1.727l.591.694.589-.638c.37-.45.819-1.057 1.347-1.82.527-.764 1.062-1.582 1.604-2.459.541-.876 1.001-1.814 1.382-2.815.381-1 .572-1.889.572-2.665 0-1.551-.534-2.87-1.604-3.959S7.028.002 5.504.002c-1.525 0-2.823.544-3.891 1.633C.544 2.724.008 4.043.008 5.594z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.c694e7933995261477bb9ede73bc9a47.svg";
export { ForwardRef as ReactComponent };